export const prioritizedCountryKeys = ['DE', 'DK', 'FI', 'NO', 'SE', 'GB', 'US'] as const;

export const countryKeys = [
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CX',
  'CY',
  'CZ',
  'DJ',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'FR_BE',
  'GA',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NL_BE',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'ST',
  'SV',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
] as const;

export type CountryKey = (typeof countryKeys)[number];
export type PrioCountryKey = (typeof prioritizedCountryKeys)[number];
export type CountryTotalKey = CountryKey | PrioCountryKey;
// Country calling codes as per ITU E.164, using base country codes (e.g., NANP members use '1').
// Notes:
// - 'FR_BE' and 'NL_BE' are language variants for Belgium; both use 32.
// - Certain territories use their administering country's code (e.g., SJ/BV -> 47, PN -> 64).
export const countryDialCodes: Record<CountryTotalKey, string> = {
  AG: '1',
  AI: '1',
  AL: '355',
  AM: '374',
  AN: '599',
  AO: '244',
  AQ: '672',
  AR: '54',
  AS: '1',
  AT: '43',
  AU: '61',
  AW: '297',
  AX: '358',
  AZ: '994',
  BA: '387',
  BB: '1',
  BD: '880',
  BE: '32',
  BF: '226',
  BG: '359',
  BH: '973',
  BI: '257',
  BJ: '229',
  BL: '590',
  BM: '1',
  BN: '673',
  BO: '591',
  BR: '55',
  BS: '1',
  BT: '975',
  BV: '47',
  BW: '267',
  BY: '375',
  BZ: '501',
  CA: '1',
  CC: '61',
  CD: '243',
  CF: '236',
  CG: '242',
  CH: '41',
  CI: '225',
  CK: '682',
  CL: '56',
  CM: '237',
  CN: '86',
  CO: '57',
  CR: '506',
  CU: '53',
  CV: '238',
  CX: '61',
  CY: '357',
  CZ: '420',
  DE: '49',
  DJ: '253',
  DK: '45',
  DM: '1',
  DO: '1',
  DZ: '213',
  EC: '593',
  EE: '372',
  EG: '20',
  EH: '212',
  ER: '291',
  ES: '34',
  ET: '251',
  FI: '358',
  FJ: '679',
  FK: '500',
  FM: '691',
  FO: '298',
  FR: '33',
  FR_BE: '32',
  GA: '241',
  GB: '44',
  GD: '1',
  GE: '995',
  GF: '594',
  GG: '44',
  GH: '233',
  GI: '350',
  GL: '299',
  GM: '220',
  GN: '224',
  GP: '590',
  GQ: '240',
  GR: '30',
  GS: '500',
  GT: '502',
  GU: '1',
  GW: '245',
  GY: '592',
  HK: '852',
  HM: '672',
  HN: '504',
  HR: '385',
  HT: '509',
  HU: '36',
  ID: '62',
  IE: '353',
  IL: '972',
  IM: '44',
  IN: '91',
  IO: '246',
  IQ: '964',
  IR: '98',
  IS: '354',
  IT: '39',
  JE: '44',
  JM: '1',
  JO: '962',
  JP: '81',
  KE: '254',
  KG: '996',
  KH: '855',
  KI: '686',
  KM: '269',
  KN: '1',
  KP: '850',
  KR: '82',
  KW: '965',
  KY: '1',
  KZ: '7',
  LA: '856',
  LB: '961',
  LC: '1',
  LI: '423',
  LK: '94',
  LR: '231',
  LS: '266',
  LT: '370',
  LU: '352',
  LV: '371',
  LY: '218',
  MA: '212',
  MC: '377',
  MD: '373',
  ME: '382',
  MF: '590',
  MG: '261',
  MH: '692',
  MK: '389',
  ML: '223',
  MM: '95',
  MN: '976',
  MO: '853',
  MP: '1',
  MQ: '596',
  MR: '222',
  MS: '1',
  MT: '356',
  MU: '230',
  MV: '960',
  MW: '265',
  MX: '52',
  MY: '60',
  MZ: '258',
  NA: '264',
  NC: '687',
  NE: '227',
  NF: '672',
  NG: '234',
  NI: '505',
  NL: '31',
  NL_BE: '32',
  NO: '47',
  NP: '977',
  NR: '674',
  NU: '683',
  NZ: '64',
  OM: '968',
  PA: '507',
  PE: '51',
  PF: '689',
  PG: '675',
  PH: '63',
  PK: '92',
  PL: '48',
  PM: '508',
  PN: '64',
  PR: '1',
  PS: '970',
  PT: '351',
  PW: '680',
  PY: '595',
  QA: '974',
  RE: '262',
  RO: '40',
  RS: '381',
  RU: '7',
  RW: '250',
  SA: '966',
  SB: '677',
  SC: '248',
  SD: '249',
  SE: '46',
  SG: '65',
  SH: '290',
  SI: '386',
  SJ: '47',
  SK: '421',
  SL: '232',
  SM: '378',
  SN: '221',
  SO: '252',
  SR: '597',
  ST: '239',
  SV: '503',
  SY: '963',
  SZ: '268',
  TC: '1',
  TD: '235',
  TF: '262',
  TG: '228',
  TH: '66',
  TJ: '992',
  TK: '690',
  TL: '670',
  TM: '993',
  TN: '216',
  TO: '676',
  TR: '90',
  TT: '1',
  TV: '688',
  TW: '886',
  TZ: '255',
  UA: '380',
  UG: '256',
  UM: '1',
  US: '1',
  UY: '598',
  UZ: '998',
  VA: '379',
  VC: '1',
  VE: '58',
  VG: '1',
  VI: '1',
  VN: '84',
  VU: '678',
  WF: '681',
  WS: '685',
  YE: '967',
  YT: '262',
  ZA: '27',
  ZM: '260',
  ZW: '263',
};

export const countryTranslationKeys = {
  DE: 'locale.DE',
  DK: 'locale.DK',
  FI: 'locale.FI',
  NO: 'locale.NO',
  SE: 'locale.SE',
  GB: 'locale.GB',
  US: 'locale.US',
  AG: 'locale.AG',
  AI: 'locale.AI',
  AL: 'locale.AL',
  AM: 'locale.AM',
  AN: 'locale.AN',
  AO: 'locale.AO',
  AQ: 'locale.AQ',
  AR: 'locale.AR',
  AS: 'locale.AS',
  AT: 'locale.AT',
  AU: 'locale.AU',
  AW: 'locale.AW',
  AX: 'locale.AX',
  AZ: 'locale.AZ',
  BA: 'locale.BA',
  BB: 'locale.BB',
  BD: 'locale.BD',
  BE: 'locale.BE',
  BF: 'locale.BF',
  BG: 'locale.BG',
  BH: 'locale.BH',
  BI: 'locale.BI',
  BJ: 'locale.BJ',
  BL: 'locale.BL',
  BM: 'locale.BM',
  BN: 'locale.BN',
  BO: 'locale.BO',
  BR: 'locale.BR',
  BS: 'locale.BS',
  BT: 'locale.BT',
  BV: 'locale.BV',
  BW: 'locale.BW',
  BY: 'locale.BY',
  BZ: 'locale.BZ',
  CA: 'locale.CA',
  CC: 'locale.CC',
  CD: 'locale.CD',
  CF: 'locale.CF',
  CG: 'locale.CG',
  CH: 'locale.CH',
  CI: 'locale.CI',
  CK: 'locale.CK',
  CL: 'locale.CL',
  CM: 'locale.CM',
  CN: 'locale.CN',
  CO: 'locale.CO',
  CR: 'locale.CR',
  CU: 'locale.CU',
  CV: 'locale.CV',
  CX: 'locale.CX',
  CY: 'locale.CY',
  CZ: 'locale.CZ',
  DJ: 'locale.DJ',
  DM: 'locale.DM',
  DO: 'locale.DO',
  DZ: 'locale.DZ',
  EC: 'locale.EC',
  EE: 'locale.EE',
  EG: 'locale.EG',
  EH: 'locale.EH',
  ER: 'locale.ER',
  ES: 'locale.ES',
  ET: 'locale.ET',
  FJ: 'locale.FJ',
  FK: 'locale.FK',
  FM: 'locale.FM',
  FO: 'locale.FO',
  FR: 'locale.FR',
  FR_BE: 'locale.FR_BE',
  GA: 'locale.GA',
  GD: 'locale.GD',
  GE: 'locale.GE',
  GF: 'locale.GF',
  GG: 'locale.GG',
  GH: 'locale.GH',
  GI: 'locale.GI',
  GL: 'locale.GL',
  GM: 'locale.GM',
  GN: 'locale.GN',
  GP: 'locale.GP',
  GQ: 'locale.GQ',
  GR: 'locale.GR',
  GS: 'locale.GS',
  GT: 'locale.GT',
  GU: 'locale.GU',
  GW: 'locale.GW',
  GY: 'locale.GY',
  HK: 'locale.HK',
  HM: 'locale.HM',
  HN: 'locale.HN',
  HR: 'locale.HR',
  HT: 'locale.HT',
  HU: 'locale.HU',
  ID: 'locale.ID',
  IE: 'locale.IE',
  IL: 'locale.IL',
  IM: 'locale.IM',
  IN: 'locale.IN',
  IO: 'locale.IO',
  IQ: 'locale.IQ',
  IR: 'locale.IR',
  IS: 'locale.IS',
  IT: 'locale.IT',
  JE: 'locale.JE',
  JM: 'locale.JM',
  JO: 'locale.JO',
  JP: 'locale.JP',
  KE: 'locale.KE',
  KG: 'locale.KG',
  KH: 'locale.KH',
  KI: 'locale.KI',
  KM: 'locale.KM',
  KN: 'locale.KN',
  KP: 'locale.KP',
  KR: 'locale.KR',
  KW: 'locale.KW',
  KY: 'locale.KY',
  KZ: 'locale.KZ',
  LA: 'locale.LA',
  LB: 'locale.LB',
  LC: 'locale.LC',
  LI: 'locale.LI',
  LK: 'locale.LK',
  LR: 'locale.LR',
  LS: 'locale.LS',
  LT: 'locale.LT',
  LU: 'locale.LU',
  LV: 'locale.LV',
  LY: 'locale.LY',
  MA: 'locale.MA',
  MC: 'locale.MC',
  MD: 'locale.MD',
  ME: 'locale.ME',
  MF: 'locale.MF',
  MG: 'locale.MG',
  MH: 'locale.MH',
  MK: 'locale.MK',
  ML: 'locale.ML',
  MM: 'locale.MM',
  MN: 'locale.MN',
  MO: 'locale.MO',
  MP: 'locale.MP',
  MQ: 'locale.MQ',
  MR: 'locale.MR',
  MS: 'locale.MS',
  MT: 'locale.MT',
  MU: 'locale.MU',
  MV: 'locale.MV',
  MW: 'locale.MW',
  MX: 'locale.MX',
  MY: 'locale.MY',
  MZ: 'locale.MZ',
  NA: 'locale.NA',
  NC: 'locale.NC',
  NE: 'locale.NE',
  NF: 'locale.NF',
  NG: 'locale.NG',
  NI: 'locale.NI',
  NL: 'locale.NL',
  NL_BE: 'locale.NL_BE',
  NP: 'locale.NP',
  NR: 'locale.NR',
  NU: 'locale.NU',
  NZ: 'locale.NZ',
  OM: 'locale.OM',
  PA: 'locale.PA',
  PE: 'locale.PE',
  PF: 'locale.PF',
  PG: 'locale.PG',
  PH: 'locale.PH',
  PK: 'locale.PK',
  PL: 'locale.PL',
  PM: 'locale.PM',
  PN: 'locale.PN',
  PR: 'locale.PR',
  PS: 'locale.PS',
  PT: 'locale.PT',
  PW: 'locale.PW',
  PY: 'locale.PY',
  QA: 'locale.QA',
  RE: 'locale.RE',
  RO: 'locale.RO',
  RS: 'locale.RS',
  RU: 'locale.RU',
  RW: 'locale.RW',
  SA: 'locale.SA',
  SB: 'locale.SB',
  SC: 'locale.SC',
  SD: 'locale.SD',
  SG: 'locale.SG',
  SH: 'locale.SH',
  SI: 'locale.SI',
  SJ: 'locale.SJ',
  SK: 'locale.SK',
  SL: 'locale.SL',
  SM: 'locale.SM',
  SN: 'locale.SN',
  SO: 'locale.SO',
  SR: 'locale.SR',
  ST: 'locale.ST',
  SV: 'locale.SV',
  SY: 'locale.SY',
  SZ: 'locale.SZ',
  TC: 'locale.TC',
  TD: 'locale.TD',
  TF: 'locale.TF',
  TG: 'locale.TG',
  TH: 'locale.TH',
  TJ: 'locale.TJ',
  TK: 'locale.TK',
  TL: 'locale.TL',
  TM: 'locale.TM',
  TN: 'locale.TN',
  TO: 'locale.TO',
  TR: 'locale.TR',
  TT: 'locale.TT',
  TV: 'locale.TV',
  TW: 'locale.TW',
  TZ: 'locale.TZ',
  UA: 'locale.UA',
  UG: 'locale.UG',
  UM: 'locale.UM',
  UY: 'locale.UY',
  UZ: 'locale.UZ',
  VA: 'locale.VA',
  VC: 'locale.VC',
  VE: 'locale.VE',
  VG: 'locale.VG',
  VI: 'locale.VI',
  VN: 'locale.VN',
  VU: 'locale.VU',
  WF: 'locale.WF',
  WS: 'locale.WS',
  YE: 'locale.YE',
  YT: 'locale.YT',
  ZA: 'locale.ZA',
  ZM: 'locale.ZM',
  ZW: 'locale.ZW',
} as const;
